import axios from 'axios';

const newProductsApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/publicProducts/new?page=${paramsFilter?.page || 1}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default newProductsApi;
